//跨域代理前缀
const BASE_URL = process.env.VUE_APP_API_BASE_URL

/**
 * 基础模块路径
 * @type {string}
 */
const MODULE_PATH_BASE = "/BASE-SERVE"

/**
 * 业务模块路径
 * @type {string}
 */
const MODULE_PATH_BUSSINESS = "/BUSSINESS-SERVE"


const MODULE_PATH_INTERFACE = "/INTERFACE-SERVE"
/**
 * api模块
 * @type {string}
 */
const MODULE_PATH_API = "/API-SERVE"

module.exports = {
    modulePaths: {
        ROOT: BASE_URL,
        BASE: BASE_URL + MODULE_PATH_BASE,
        BUSSINESS: BASE_URL + MODULE_PATH_BUSSINESS,
        API: BASE_URL + MODULE_PATH_API,
        WORKFLOW: BASE_URL + MODULE_PATH_BUSSINESS,  //MODULE_PATH_WORKFLOW
    },
    temp: {
        BASE_URL: `${BASE_URL}${MODULE_PATH_BASE}`,//通用路径
        BASE_CODE: `${BASE_URL}${MODULE_PATH_BASE}/comm/baseCode/getOne`,//通用代码
        AREA_CODE: `${BASE_URL}${MODULE_PATH_BASE}/comm/area/all`,//省市区
        CITY_CODE: `${BASE_URL}${MODULE_PATH_BASE}/comm/area/getProvinceAndCity`,//省市
        UPLOAD_PATH: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/upload`,//上传接口
        UPLOAD_M3U8: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/uploadInfore`,//上传m3u8接口
        UPLOAD_TALK: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/uploadForTalk`,//上传接口用于话术库 限制素材大小
        UPLOAD_LIMIT: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/uploadImgLimitSize`,//上传接口用于话术库 限制素材大小
        FILE_PATH: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/local/`,//上传路径
        FILE_EXPORT:`${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/local/`,//下载
        UPLOAD_BASE64: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/uploadBase64Img`,//上传路径Base64
        WX_UPLOAD_PATH: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/uploadWorkWx`,//企业微信附件素材上传接口 uploadType=1 附件 uploadType=2 素材
        WX_UPLOAD_IMG_PATH: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/uploadImgToWorkWx`,//企业微信图片上传接口

    },
    // qf33
    base: {
        LOGIN: `${BASE_URL}${MODULE_PATH_BASE}/sys/login`,//登录
        LOGOUT: `${BASE_URL}${MODULE_PATH_BASE}/sys/logout/0`,//退出登录
        ROUTES: `${BASE_URL}${MODULE_PATH_BASE}/sys/menu/nav`,//菜单
        USER: `${BASE_URL}${MODULE_PATH_BASE}/sys/user/currentUser`,//当前用户信息
        PERMISSIONS: `${BASE_URL}${MODULE_PATH_BASE}/sys/menu/permissions`,//权限配置
        CODEIMG: `${BASE_URL}${MODULE_PATH_BASE}/captcha.jpg`,//验证码
    },
    comm: {
        SYS: `${BASE_URL}${MODULE_PATH_BASE}/sys`,//管理根路径
        USER: `${BASE_URL}${MODULE_PATH_BASE}/sys/user`,//用户管理
        MENU: `${BASE_URL}${MODULE_PATH_BASE}/sys/menu`,//菜单管理
        ROLE: `${BASE_URL}${MODULE_PATH_BASE}/sys/role`,//角色管理
        DEALER: `${BASE_URL}${MODULE_PATH_BASE}/sys/deptRegionDealer/pageDealerList`,//经销商管理
        DEPT: `${BASE_URL}${MODULE_PATH_BASE}/sys/dept`,//部门管理
        ECTASKPROMPT: `${BASE_URL}${MODULE_PATH_BASE}/ec/taskPrompt`,//消息提醒
        ECSETTINGS: `${BASE_URL}${MODULE_PATH_BASE}/ec/settings`,//参数管理
        STATIONMESSAGE: `${BASE_URL}${MODULE_PATH_BASE}/ec/stationMessage`,//参数管理
        COST: `${BASE_URL}${MODULE_PATH_INTERFACE}/app/sale/clue/getCostList`,//线索管理
        SCHEDULE: `${BASE_URL}${MODULE_PATH_BASE}/sys/schedule`,//定时任务
        SCHEDULELOG: `${BASE_URL}${MODULE_PATH_BASE}/sys/scheduleLog`,//定时任务
        BASE_CODE: `${BASE_URL}${MODULE_PATH_BASE}/comm/baseCodeHead`,//通用代码管理
        LOG: `${BASE_URL}${MODULE_PATH_BASE}/sys/log/list`,//系统日志
        LOGEXPORT: `${BASE_URL}${MODULE_PATH_BASE}/sys/log/exportExcel?`,//系统日志导出
        UPLOAD: `${BASE_URL}${MODULE_PATH_BASE}/sys/dept/importAgent`,//成员管理上传
    },
    workflow: {  //MODULE_PATH_WORKFLOW
        WORK_FLOW: `${BASE_URL}${MODULE_PATH_BUSSINESS}/sys/workflow`,//审批流配置
        WORK_FLOW_TASK: `${BASE_URL}${MODULE_PATH_BUSSINESS}/act/task`,//审批撤销
        WORK_INFO: `${BASE_URL}${MODULE_PATH_BUSSINESS}/act/process/instanceInfo`,//审批流程
        MODEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/act/model`,//模型管理
        WORK_FLOW_MANAGE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/act/process`,//流程管理
        WORK_FLOW_FINISH: `${BASE_URL}${MODULE_PATH_BUSSINESS}/act/task/finished`,//办理历史
    },
	plan:{
		PLAN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan`,//活动计划(厂家)
		GETDEPTCOUNT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/getDeptCount`,//活动计划(厂家)
		RECEIVEDEPT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/receiveDept`,//活动计划（经理部/经销商）
		RECEIVEDEPTUSER: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/receiveDeptUser`,//活动计划（销售顾问）
		CLUE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/sale/clue`,//品系
		ACTIVITYTYPE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/activityType/all`,//活动类型
		UPDATEPLAN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan`,//编辑
        IMPORTTABLE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/importActiveDept/`,//导入表格
		PROVIDE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/provide`,//导入表格
		DEPT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/sys/dept`,//导入表格
		FINISH: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/getAddDeptFinish`,//完成情况接口编辑子表
		MAIN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/exportExcelMain`,//厂家导出
		DEALER: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/exportExcelDealer`,//经理部经销商导出
		USER: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/exportExcelUser`,//销售顾问导出
		CHECK: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/plan/exportExcel`,//销售顾问导出
	},
    visit:{
        VISIT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visit/pageList`,
        DETAIL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visit`,//详情
        MAIN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visit/exportExcelMain`,//厂家导出
        CHECK: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visit/exportExcel`,//销售顾问导出
        PLAN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/visit/plan`,//拜访计划管理
        UPLOAD: `${BASE_URL}${MODULE_PATH_BUSSINESS}/visit/plan/importPlan`,//拜访计划管理上传
        ERROREXCEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/visit/plan/local/`,//线索池--下载异常错误信息
        SELECT_DEPT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/visit/plan/popSelectVisit`,
        DEPT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/visit/plan`,//部门管理
    },
    followRecord:{
        VISIT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/followRecord/pageList`,
        DETAIL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/followRecord/detail`,//详情
        DETAIL_FOLLOW_RECORD: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/followRecord/detailFollowRecord`,//跟进详情
    },
    visitTask:{
        VISIT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visitTask/pageList`,
        INSERT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visitTask/insert`,
        DETAIL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visitTask/detail`,
        UPDATE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visitTask/update`,
        DEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visitTask/del`,
        IMPORT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/bigCustomer/visitTask/import`,
    },
    clue: {
        CLUE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/sale/clue`,//线索管理
        REPORT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/sale/clubReport`,//线索跟进记录
        REPORTALL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/sale/clubReport/getPageList`,//跟进记录
        CLUEPOOL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCluePool`,//线索池列表
        CLUEPOOLDeptList: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCluePool`,//线索池列表
        DealerImportUPLOAD: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCluePool/dealer/importAgent`,//线索池--经销商导入
        FactorImportUPLOAD: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCluePool/factor/importAgent`,//线索池--厂家导入
        ERROREXCEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCluePool/local/`,//线索池--下载异常错误信息
        GETPOOLERROR: `${BASE_URL}${MODULE_PATH_BASE}/sys/oss/local/error/`,//线索池--厂家导入下载失败数据
        SELECT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/getCategory`,//三级联动行业
        GETCOMPANYINFO: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/getCompanyPosition`,//公司经纬度
        GETCOMPANYLIST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/getCustMapList`,//公司列表信息
        GETCOMPANYDETAIL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/getCompanyDetail?companyName=`,//公司详细信息
        BATCHCOLLECTION: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/receiveCust`, // 批量领取
        GETCOORDINATE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/getIpAddr`,// 获取本地坐标
        AREA_CODE_AGAIN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/getArea`,//省市区
        DISTRIBUTE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/cluePoolAssign`,//分配列表
        RECEIVE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/cluePoolReceive`,//领取列表
        CLUERULECONFIG: `${BASE_URL}${MODULE_PATH_BUSSINESS}/clueRuleConfig`,//线索规则
        CLUETOUCHCHANNEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/clueTouchChannel`,//触达渠道配置
    },
    label: {
        GROUPLIST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTagGroup/all`,// SCRM标签分组表列表 所有
        ADDGROUP: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTagGroup`,// 新增 删除 SCRM标签分组表
        TAGGROUP: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTagGroup`,// 标签通用
    },
    attributes:{
        ATTRIBUTESLIST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/msgSendSop`,// 客户属性分类
    },
    operate: {//客户运营
        MASS_SEND_WORK: `${BASE_URL}${MODULE_PATH_BUSSINESS}/work`,//群发工作相关接口
        MASS_SEND_CIRCLE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/work/wxMomentsTask`,//群发朋友圈
        MASS_SEND_CUSTOMER: `${BASE_URL}${MODULE_PATH_BUSSINESS}/work/wxMsgTask`,//群发客户群消息
        SEND_WELCOME_MSG: `${BASE_URL}${MODULE_PATH_BUSSINESS}/work/wxSendWelcomeMsg`,//新客户欢迎语
        WELCOME_CODE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/work/wxWelcomeCode`,//欢迎语素材
        MARKETINGFISSION: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/marketingFission`,//营销裂变
        MARKETINGFISSIONWIN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/marketingFissionWin`,//营销裂变中奖信息
        BROCHURE_LIST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/productBrochure`,// 产品宣传册列表
        WECHATCODE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/marketingLiveCode`,// 企微活码
        VOID: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/marketingLiveCode/cancleData`, //企微活码作废
        TAGAll: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTag/getScrmTagAll`,//客户标签表 所有
        SOPLIST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/msgSendSop`,//客户SOP群发列表 所有
        FISSION: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/marketingFission`,//客户裂变统计接口前缀
    },
    // qf34
    client: {
        SHARE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/custShare`,//客户共享记录表列表
        LABEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTag`,//标签管理表
        FOLLOWUP: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/custFollow`,//客户跟进记录表
        TAG: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTag`,//客户标签表
        CUSTTAG: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/custTag`,//客户标签表
        CUSTOMER: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust`,//客户表
        INFO: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/detail`,//
        SAVE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust`,// 保存
        DATA_SYNC: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/syncCustUserInfo`,//数据同步
        SIGN: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/updateCustInfo`,//标记
        SELECTION: `${BASE_URL}${MODULE_PATH_BASE}/sys/dept/popSelect`,//经理部 经销商
        INHERIT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust`,//离职成员列表
        SCRM: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm`,//BUSSINESS->SCRM路径
        SAVECAR:`${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/custVehicle`,//保有车辆
        CUSTOMERARCHIVES: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/customerarchives`,//客户档案
        exportExcel: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/exportExcel`,//导出
        archivesExportExcel: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/archivesExportExcel`,//导出
        MAINTAINCUST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/maintainCust`,//客户档案
    },
    report: {
        REPORT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/report`, //报表公共接口域名
        REPORTACTIVITY: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/acitvity`, //报表公共接口域名activity
        REPORTACTIVITYTYPE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/activityType`, //报表公共接口域名activityType
        REPORTEXPORT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/acitvity/export`, //报表导出公共接口域名85export
        CLUBREPORT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/exportExcelData`, //下载中心
        CLUBREPORTMODULE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/exportType`, //下载中心功能模块
        DOWMLOADEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/saleCust/exportExcelData`,//下载中心删除
    },
    market: {
        LABEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/spreadContent`,// 传播内容表，文章和视频共用表列表
        TAGAll: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commTag/all`,//客户标签表 所有
        SPREADPOSTER: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/spreadPoster`,//海报
        ACT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/marketingActivity`,//活动
    },
    answer: {
        QUESTION: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/question`,//企业问题
        QUESTIONTYPE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/questionType`,//企业问题类型
        KEYWORDS: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/keyWords`,//企业问题关键词
        SPEECH: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commonSpeech`,//常用语
        SPEECHTYPE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/commonSpeechType`,//常用语分组
        EXTERNALTYPE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/externalInfoType`,//对外资料分组
        EXTERNAL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/externalInfo`,//企业常用语分组
        ANSWERUPLOAD: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/question/importQuestion`,//常见问题导入
        COMMONTREE: `${BASE_URL}${MODULE_PATH_BASE}/comm/baseCodeHead/detail/getOneCodeDetail`,//通用树结构
        SAVETREE: `${BASE_URL}${MODULE_PATH_BASE}/comm/baseCodeDetail`,//通用保存 删除树结构

    },
    activity: {
        ACTIVITY: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/acitvity`,//活动列表
        ACTIVITYCOUNTLIST: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/acitvity/queryNoAccountData`,//活动报账的弹出列表
        ACTIVITYTYPEALL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/activityType/all`,//所有活动类型列表
        ACTIVITYTYPE: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/activityType/`,//活动类型列表
        GETACTIVITYQR: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/acitvity/getActivityQr/`,//活动类型列表
        ACTIVITYACCOUNT: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/activityAccount`,//活动报账列表

    },
    index: {
        INDEX_API: `${BASE_URL}${MODULE_PATH_BUSSINESS}/customer`,//首页
        INDEX_API_DATA: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/indexApi`,//首页数据简报
        // INDEZ_FUNNEL: `${BASE_URL}${MODULE_PATH_BUSSINESS}/scrm/indexApi/querySaleFunnel` // 首页漏斗图
    },

}
